import React from 'react';
import { Box } from '@mui/material';

const OnlineDot = ({ isOnline, paperBg }) => {
  if (!isOnline) return null;
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 1,
        right: 1,
        width: 10,
        height: 10,
        borderRadius: '50%',
        bgcolor: '#44b700',
        border: `2px solid ${paperBg}`,
        boxSizing: 'content-box',
      }}
    />
  );
};

export default OnlineDot;
